import { useEffect, useState } from "react";
import ModalWindow from "../../../../../../../Components/ModalWindow/ModalWindow.js";
import ScrollableList from "../../../../../../../Components/ScrollableList/ScrollableList.js";
import InGameRoles from "../../../../../../../Services/Api/InGameRoles.ts";
import AddEditRoleModal from "../AddEditRoleModal/AddEditRoleModal.js";
import { MdEdit } from "react-icons/md";

const InGameRolesList = ({setShowRolesList, groupId}) => {
    const inGameRoles = new InGameRoles();

    const [roles, setRoles] = useState(null);
    const [showAdd, setShowAdd] = useState(false);
    const [editData, setEditData] = useState(null);

    useEffect(() => {
        refresh();
    }, [])

    const refresh = () => {
        inGameRoles.GetAll(data => {
            
            const processedData = data.map(role => {
                return {
                    id: role.id,
                    columns: [
                        <div>
                            <h3>{role.roleName}</h3>
                            <div className="flex gap-3 text-glwhite-600"> 
                                <p>Priorytet: {role.priority}</p>
                                <p>Id na discordzie: {role.discordRoleId}</p>
                            </div>
                        </div>
                    ],
                    text: role.roleName
                }
            })

            setRoles({processedData: processedData, data: data});
        })
    }

    const edit = (id) => {
        const role = roles.data.find(x => x.id == id);

        if(role) {
            setEditData(role);
            setShowAdd(true);
        }     
    }

    const remove = (id) => {
        inGameRoles.Delete(id, () => {refresh();});
    }

    if(!roles)
        return (<ModalWindow content={<div className="text-center">Ładowanie danych...</div>} />);


    return (
        <>
            <ModalWindow 
                closeFunction={() => setShowRolesList(false)}
                minWidth={"50%"}
                content={
                    <ScrollableList 
                        removeTitle={"Usunięcie roli"}
                        removeText={<div>Czy na pewne chcesz kontynuować? <span className="text-glred">Rola zostanie usunięta u wszystkich graczy!</span></div>}
                        removeFunction={remove}
                        setShowAdd={(bool) => {setEditData(null); setShowAdd(bool)}}
                        data={roles.processedData}
                        customButtons={[
                            { icon: <MdEdit size={"22px"} className="iconBtn"/>, onClick: (data) => {edit(data.id)} }
                        ]}
                        listClass={"overflow-y-auto overflow-x-hidden h-[41vh]"}
                    />
                }
            />        
            { showAdd &&
                <AddEditRoleModal refresh={refresh} editData={editData} setShowAdd={setShowAdd} groupId={groupId}/>
            }
        </>
    )
}

export default InGameRolesList;